import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics, trackWebVital } from './analytics';

initializeAnalytics({
  appName: 'TrackNList Site',
  sourceSurface: 'site',
  measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID_SITE,
  enabled: process.env.REACT_APP_ANALYTICS_ENABLED !== 'false',
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(trackWebVital);
